import { getDownstreamHostsValue } from "@swiggy-private/checkout-core";

export const FETCH_ORDER_DETAILS_ENDPOINT = "/api/v1/dash/oms/order/{0}/context/ORDER_JOB?includeRemainingDineCash={1}";
export const FETCH_BANNER_ENDPOINT = "/api/v1/json/landing-page/DINEOUT_POST_PAYMENT";
export const FETCH_BOOKING_DETAILS_ENDPOINT = "/api/v1/booked-deal-details/order/{0}/json?subPage={1}";
export const FETCH_CART_ENDPOINT = "/api/v3/dineout/view/DINEOUT";
export const FETCH_VOUCHER_ENTITY_ENDPOINT = "/api/v1/entity/DINECASH_DEAL_DETAIL/{0}/json";
export const FETCH_CART_COUPON_ENDPOINT = "/api/v3/dineout/view/apply-coupon";
export const CANCEL_BOOKING_URI = "/api/v1/dash/oms/{0}/cancel";
export const SPLIT_BILL_ENDPOINT = "/api/v1/dash/oms/split-bill-comms";

export const DOWNSTREAM_HOSTS = {
    DISC_SWIGGY: getDownstreamHostsValue("CART_HABIT_FORMING_HOST") ?? "https://disc.swiggy.com",
    DASH_HOST: getDownstreamHostsValue("DASH_HOST") ?? "https://dinersone-proxy.swiggy.com",
    DO_HOST: getDownstreamHostsValue("DO_HOST") ?? "https://dinersone-proxy.swiggy.com",
    CHECKOUT_WEB_APP_HOST: getDownstreamHostsValue("CHECKOUT_WEB_APP_HOST") ?? "https://payments.swiggy.com",
};
